import types from './challengeTypes.js'
import processRevchallengeStreamItems from '@/lib/processRevStreamItems.js'
import defaults from './challengeDefaults.js'
import challengeModel from './model.js'

const mutations = {
  [types.SET_CHALLENGES](state, payload) {
    state.challenges = payload.challenges
  },

  [types.CLEAR_CHALLENGES](state) {
    state.challenges = []
  },

  [types.SET_TOTAL_CHALLENGES](state, total) {
    state.totalChallenges = total
  },

  [types.SET_CHALLENGE](state, payload) {
    state.challenge = payload.challenge
  },

  [types.CLEAR_CHALLENGE](state) {
    state.challenge = JSON.parse(JSON.stringify(challengeModel))
  },

  [types.SET_REWARDS](state, payload) {
    state.challenge.rewards = payload.rewards
  },

  [types.CLEAR_REWARDS](state) {
    state.challenge.rewards = defaults.challenge.rewards
  },

  [types.SET_CHALLENGE_REVS](state, payload) {
    const items = processRevchallengeStreamItems(payload.revs)

    items.forEach(item => {
      state.revs.push(item)
    })
  },

  [types.CLEAR_CHALLENGE_REVS](state) {
    state.revs = []
  },

  [types.SET_CHALLENGE_LEADERBOARD_RANKING](state, payload) {
    state.leaderboard = payload.ranking
  },

  [types.CLEAR_CHALLENGE_LEADERBOARD_RANKING](state) {
    state.leaderboard = []
  },

  [types.SET_REWARD](state, payload) {
    state.challenge.rewards.splice(payload.index, 1, payload.reward)
  },

  [types.SET_CHALLENGE_FIELD](state, payload) {
    state.challenge[payload.field] = payload.value
  },

  [types.UPDATE_CHALLENGE_REWARD](state, payload) {
    const currentReward = state.challenge.rewards[payload.index]
    currentReward[payload.field] = payload.value
    state.challenge.rewards.splice(payload.index, 1, currentReward)
  },

  [types.SET_CHALLENGE_COMMENTS](state, payload) {
    state.comments = payload.comments
  },

  [types.CLEAR_CHALLENGE_SITE](state) {
    state.challengeStream.filters.site = defaults.challengeStream.filters.site
  },

  [types.SET_CHALLENGE_SITE](state, payload) {
    state.challengeStream.filters.site = payload.site
  },

  [types.CLEAR_CHALLENGE_COLLABORATORS](state) {
    state.challengeStream.filters.collaborators =
      defaults.challengeStream.filters.collaborators
  },

  [types.ADD_CHALLENGE_COLLABORATOR](state, payload) {
    state.challengeStream.filters.collaborators.push(payload.collaboratorId)
  },

  [types.REMOVE_CHALLENGE_COLLABORATOR](state, payload) {
    state.challengeStream.filters.collaborators = state.challengeStream.filters.collaborators.filter(
      collaborator => {
        if (collaborator !== payload.collaboratorId) {
          return collaborator
        }
      }
    )
  },

  [types.SET_CHALLENGE_MAINSTREAM_FILTER](state, payload) {
    state.challengeStream.filters[payload.type] = payload._id
  },

  [types.REMOVE_CHALLENGE_MAINSTREAM_FILTER](state, payload) {
    state.challengeStream.filters[payload.type] = null
  },

  [types.CLEAR_CHALLENGE_STREAM_QUERY](state) {
    state.challengeStream = {}
    state.challengeStream = JSON.parse(JSON.stringify(defaults.challengeStream))
  },

  [types.SET_CHALLENGE_STREAM_QUERY](state, payload) {
    state.challengeStream = payload
  },
}

export default mutations
